export const TENANT_SETTINGS_INITIAL_STATE = {
    settingVisibility: {
        Breed: {
            id: '',
            settingName: 'enableBreed',
            displayName: '',
            isActive: false,
        },
        Color: {
            id: '',
            settingName: 'enableColor',
            displayName: '',
            isActive: false,
        },
        Sex: {
            id: '',
            settingName: 'enableSex',
            displayName: '',
            isActive: false,
        },
        KillGroup: {
            id: '',
            settingName: 'enableKillGroup',
            displayName: '',
            isActive: false,
        },
        DOA: {
            id: '',
            settingName: '',
            displayName: '',
            isActive: false,
        },
        Cut: {
            id: '',
            settingName: '',
            displayName: '',
            isActive: false,
        },
        SecondBuyer: {
            id: '',
            settingName: '',
            displayName: '',
            isActive: false,
        },
        PickupDateRange: {
            id: '',
            settingName: '',
            displayName: '',
            isActive: false,
        },
        Slides: {
            id: '',
            settingName: '',
            displayName: '',
            isActive: true,
        },
        TraditionalAll: {
            id: '',
            settingName: '',
            displayName: '',
            isActive: true,
        },
        TraditionalSplit: {
            id: '',
            settingName: '',
            displayName: '',
            isActive: true,
        },
        California: {
            id: '',
            settingName: '',
            displayName: '',
            isActive: true,
        },
        HardStop: {
            id: '',
            settingName: '',
            displayName: '',
            isActive: true,
        },
    },
    loading: false,
    filter: {
        destinationFilter: {
            show: 'active',
            name: '',
        },
        buyLocationFilter: {
            show: 'active',
            name: '',
        },
        truckingCompanyFilter: {
            show: 'active',
            name: '',
        },
        ownerFilter: {
            show: 'active',
            name: '',
        },
        buyerFilter: {
            show: 'active',
            name: '',
        },
        payeeFilter: {
            show: 'active',
            name: '',
        },
    },
};
